<template>
  <v-container fluid class="pt-5">
    <validation-observer v-slot="{ invalid }">
      <base-material-card
        color="primary"
        icon="mdi-map-marker"
        inline
        class="px-5 py-4 ml-0"
        :key="id"
        title="Gerenciar Municípios da Área de Concessão"
        elevation="0"
      >
        <v-row class="mx-auto mt-2">
          <v-col cols="12" class="pb-0">
            <span class="display-1 font-weight-bold">
              <v-icon color="primary">
                mdi-map-marker-outline
              </v-icon>
              Selecionar Municípios
            </span>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col cols="12">
            <v-expansion-panels v-model="panelMunicipiosEmMassa" flat>
              <v-expansion-panel class="borda">
                <v-expansion-panel-header>
                  Selecionar municípios em massa
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-textarea
                    v-model="municipiosTexto"
                    label="Códigos dos Municípios"
                    placeholder="Insira um código de município por linha. Exemplo:
1200013
1200054
1200328
"
                    hint="Insira os códigos dos municípios, 1 por linha"
                    outlined
                    rows="5"
                    clearable
                  />
                  <v-row justify="end">
                    <v-col cols="auto">
                      <v-btn
                        color="primary"
                        class="mt-3"
                        @click="selecionarMunicipiosPorTexto"
                      >
                        Selecionar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="filteredMunicipios"
              item-value="id"
              :loading="loadingMunicipios"
              class="borda"
              :mobile-breakpoint="10"
              :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageOptions: [10, 50, 100, 300, -1],
              }"
            >
              <template v-slot:top>
                <div
                  v-if="
                    municipiosSelecionadosIsDirty &&
                      municipiosSelecionados.length < 1
                  "
                  class="error--text font-weight-bold mx-4 pt-3"
                >
                  Selecione pelo menos 1 município.
                </div>

                <div class="font-weight-bold mx-4 pt-3">
                  {{ municipiosSelecionados.length }} município(s)
                  selecionado(s).
                </div>

                <v-row class="mt-4" align="center" justify="space-between">
                  <v-col cols="12" sm="4" class="py-0 pr-sm-3">
                    <v-text-field
                      v-model="searchMunicipios"
                      label="Pesquisar"
                      class="mx-4 mb-4"
                      append-icon="mdi-magnify"
                      single-line
                      hide-details
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" sm="4" class="py-0 pl-sm-3">
                    <v-autocomplete
                      v-model="selectedUf"
                      :items="itemsFiltroUf"
                      label="Filtrar UF"
                      class="mx-4 mb-4"
                      clearable
                      hide-details
                    />
                  </v-col>
                </v-row>
              </template>

              <template v-slot:header.select>
                <v-checkbox
                  :input-value="allMunicipiosSelected"
                  :indeterminate="someMunicipiosSelected"
                  @change="toggleSelectAllMunicipios()"
                  color="primary"
                  hide-details
                  class="ma-0 pa-0"
                />
              </template>
              <template v-slot:item.select="{ item }">
                <v-checkbox
                  :input-value="municipiosSelecionados.includes(item.id)"
                  @change="toggleSelectMunicipio(item.id)"
                  color="primary"
                  hide-details
                  class="ma-0 pa-0"
                />
              </template>
            </v-data-table>
            <validation-provider v-slot="{ errors }" rules="required">
              <input type="hidden" :value="municipiosSelecionados.join('')" />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mx-auto" justify="end">
          <v-col cols="auto">
            <v-btn
              color="accent"
              min-width="100"
              :loading="loading"
              @click="openConfirmDialog()"
              :disabled="invalid || !hasAlteracoes"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>
    </validation-observer>
    <v-dialog v-model="dialogConfirmarSalvar" max-width="700">
      <v-card>
        <v-card-title class="text-h6">
          Confirmar alterações
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            Revise as alterações antes de confirmar.
          </div>
          <div v-if="municipiosAdicionados.length > 0" class="mb-3">
            <div class="font-weight-medium">
              Municípios que serão adicionados:
            </div>
            <div class="texto-revisao">
              {{
                municipiosAdicionados
                  .map((m) => `${m.nome_municipio}/${m.nome_uf}`)
                  .join(", ")
              }}
            </div>
          </div>
          <div v-if="municipiosRemovidos.length > 0" class="mb-3">
            <div class="font-weight-medium">
              Municípios que serão removidos:
            </div>
            <div class="texto-revisao">
              {{
                municipiosRemovidos
                  .map((m) => `${m.nome_municipio}/${m.nome_uf}`)
                  .join(", ")
              }}
            </div>
          </div>
          <div v-if="!hasAlteracoes" class="texto-revisao">
            Nenhuma alteração identificada.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogConfirmarSalvar = false">
            Cancelar
          </v-btn>
          <v-btn color="accent" :loading="loading" @click="confirmarSalvar()">
            Confirmar e salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import AreaConcessaoService from "@/services/AreaConcessaoService";
import MunicipiosService from "@/services/MunicipiosService";

export default {
  name: "AreasConcessaoEdit",
  data() {
    return {
      loading: false,
      headers: [
        { text: "", value: "select", sortable: false, width: "60px" },
        { text: "Código IBGE", value: "codigo_municipio" },
        { text: "Município", value: "nome_municipio" },
        { text: "UF", value: "nome_uf" },
      ],
      searchMunicipios: "",
      itemsFiltroUf: [],
      selectedUf: null,
      loadingMunicipios: false,
      municipios: [],
      municipiosSelecionados: [],
      municipiosSelecionadosOriginais: [],
      municipiosSelecionadosIsDirty: false,
      municipiosTexto: "",
      panelMunicipiosEmMassa: null,
      dialogConfirmarSalvar: false,
    };
  },
  computed: {
    id() {
      return this.$route.params.id ?? null;
    },
    hasAlteracoes() {
      return (
        this.municipiosAdicionados.length > 0 ||
        this.municipiosRemovidos.length > 0
      );
    },
    municipiosAdicionados() {
      const originais = new Set(this.municipiosSelecionadosOriginais);
      return this.municipios.filter(
        (m) =>
          this.municipiosSelecionados.includes(m.id) && !originais.has(m.id),
      );
    },
    municipiosRemovidos() {
      const atuais = new Set(this.municipiosSelecionados);
      return this.municipios.filter(
        (m) =>
          this.municipiosSelecionadosOriginais.includes(m.id) &&
          !atuais.has(m.id),
      );
    },
    allMunicipiosSelected() {
      return (
        this.municipiosSelecionados.length > 0 &&
        this.municipiosSelecionados.length === this.municipios.length
      );
    },
    someMunicipiosSelected() {
      return (
        this.municipiosSelecionados.length > 0 &&
        this.municipiosSelecionados.length < this.municipios.length
      );
    },
    filteredMunicipios() {
      let filtered = this.municipios;

      if (this.selectedUf) {
        filtered = filtered.filter((m) => m.nome_uf === this.selectedUf);
      }

      if (this.searchMunicipios) {
        const search = this.searchMunicipios.toLowerCase();
        filtered = filtered.filter(
          (municipio) =>
            municipio.nome_municipio.toLowerCase().includes(search) ||
            municipio.nome_uf.toLowerCase().includes(search) ||
            municipio.codigo_municipio.toString().includes(search),
        );
      }

      return filtered;
    },
  },
  async mounted() {
    await this.getMunicipiosVinculadosDaEmpresa();
    await this.getMunicipios();
  },
  methods: {
    async getMunicipiosVinculadosDaEmpresa() {
      try {
        const municipiosVinculados = await MunicipiosService.getMunicipiosByCompany();
        this.municipiosSelecionadosOriginais = municipiosVinculados.map(
          (m) => m.id,
        );
        this.municipiosSelecionados = [...this.municipiosSelecionadosOriginais];
      } catch (error) {
        console.error(error);
      }
    },
    async getMunicipios() {
      this.loadingMunicipios = true;
      this.selectedUf = null;
      this.municipios = [];

      try {
        const data = await AreaConcessaoService.getAllForAdd();
        this.municipios = data.map((item) => ({
          id: item.id,
          codigo_municipio: item?.codigo_municipio,
          nome_municipio: item?.nome_municipio,
          nome_uf: item?.nome_uf,
          company_id: item?.company_id,
        }));

        this.itemsFiltroUf = [
          ...new Set(
            this.municipios
              .map((m) => m.nome_uf)
              .filter(Boolean)
              .sort(),
          ),
        ];
      } catch (error) {
        console.error(error);
        this.$toast.error("Ocorreu um erro ao buscar os Municípios", "", {
          position: "topRight",
        });
      } finally {
        this.loadingMunicipios = false;
        this.municipiosSelecionadosIsDirty = false;
      }
    },
    toggleSelectAllMunicipios() {
      const filteredIds = this.filteredMunicipios.map((m) => m.id);
      const selecionados = new Set(this.municipiosSelecionados);
      const todosFiltradosSelecionados = filteredIds.every((id) =>
        selecionados.has(id),
      );

      if (todosFiltradosSelecionados) {
        filteredIds.forEach((id) => selecionados.delete(id));
      } else {
        filteredIds.forEach((id) => selecionados.add(id));
      }

      this.municipiosSelecionados = Array.from(selecionados);
    },
    toggleSelectMunicipio(id) {
      const index = this.municipiosSelecionados.indexOf(id);
      index === -1
        ? this.municipiosSelecionados.push(id)
        : this.municipiosSelecionados.splice(index, 1);
    },
    selecionarMunicipiosPorTexto() {
      const municipiosTextoArray = this.municipiosTexto
        .split("\n")
        .map((item) => item.trim())
        .filter(Boolean);

      this.municipiosSelecionados = this.municipios
        .filter((m) =>
          municipiosTextoArray.includes(m.codigo_municipio.toString()),
        )
        .map((m) => m.id);

      if (this.municipiosSelecionados.length > 0) {
        this.$toast.success(
          `${this.municipiosSelecionados.length} município(s) selecionado(s).`,
          "",
          { position: "topRight", timeout: 2000 },
        );

        this.panelMunicipiosEmMassa = null;
      } else {
        this.$toast.error("Nenhum município encontrado.", "", {
          position: "topRight",
          timeout: 3000,
        });
      }
    },
    openConfirmDialog() {
      if (!this.hasAlteracoes) return;
      this.dialogConfirmarSalvar = true;
    },
    async confirmarSalvar() {
      this.dialogConfirmarSalvar = false;
      await this.saveData();
    },
    async saveData() {
      this.loading = true;

      try {
        const postData = {
          municipios: this.municipiosSelecionados,
        };

        await AreaConcessaoService.update(postData);

        this.$toast.success("Vínculos de municípios salvos com sucesso.", "", {
          position: "topRight",
        });

        this.$router.push(`/administracao/area-concessao`);
      } catch (err) {
        console.error(err);

        this.$toast.error(
          "Ocorreu um erro ao salvar os vínculos de municípios",
          "",
          {
            position: "topRight",
          },
        );
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    municipiosSelecionados() {
      this.municipiosSelecionadosIsDirty = true;
    },
  },
};
</script>

<style>
.borda {
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.texto-revisao {
  max-height: 220px;
  overflow-y: auto;
}
</style>
